import moment from 'moment';

export default {
  data() {
    return {};
  },

  mounted() { },

  methods: {
    getDays(dateTime1, dateTime2) {
      var a = moment(new Date(dateTime1));
      var b = moment(new Date(dateTime2));
      return a.diff(b, 'days')   // =1
    },

    getHours(dateTime1, dateTime2) {
      var a = moment(new Date(dateTime1));
      var b = moment(new Date(dateTime2));
      return a.diff(b, 'hours')   // =1
    },

    setAgos(job) {
      var days = Math.abs(this.getDays(job.CreatedDate, new Date()));
      job.daysAgo = days;
      if (days === 0) {
        var hours = Math.abs(this.getHours(job.CreatedDate, new Date()));
        job.hoursAgo = hours;
      }
      return job;
    },
  },

  computed: {},

  watch: {},
}